/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-comment-textnodes */
import React from "react";
import { withTranslation } from "react-i18next";
import { Anchor } from "hesus-ui-kit";
import {
  renderPriceWithCurrency,
  addSpace,
  getConvertedPrice,
} from "@utils/utils";
import {
  SectionContainer,
  OrderHeaderWrapper,
  FlexRow,
  Title,
  GridRow,
  GridSubItem,
} from "./OrderPlanningHistory.styled";
import "../../SupplierList.scss";

const OrderSummaryHistory = (props) => {
  const { t, orderData, exchangeRates, quoteCurrency, siteId } = props;
  return (
    <SectionContainer>
      <OrderHeaderWrapper>
        <FlexRow>
          <Title color="#fff" bottom="0px">
            <Anchor
              className="supplier-list__link"
              onClick={`/site/view/${siteId}/enquiry-view-${orderData?.sellingPrice?.enquiryId}`}
              target="_blank"
            >
              {t("ENQUIRY") + " #" + orderData?.sellingPrice?.enquiryId}
            </Anchor>{" "}
            {" - "}
            {orderData?.label}
          </Title>
        </FlexRow>
      </OrderHeaderWrapper>

      {orderData?.serviceItems?.map((item, itemIndex) => {
        return (
          <React.Fragment key={"service-item-" + item?.id + itemIndex}>
            <GridRow
              column="1fr auto 25%"
              gap="0rem"
              borderRight="2px solid #767676"
              borderLeft="2px solid #767676"
              borderBottom="2px solid #767676"
              borderRadius={
                orderData?.serviceItems?.length === itemIndex + 1
                  ? "5px"
                  : "0px"
              }
            >
              <GridRow gap="0rem">
                <GridSubItem
                  fontWeight="700"
                  fontSize="16px"
                  padding="5px 5px 5px 10px"
                >
                  {item.hesusService.name}
                </GridSubItem>
                <GridSubItem
                  fontWeight="400"
                  fontSize="16px"
                  color="#474747"
                  fontStyle="italic"
                  padding="5px 5px 5px 10px"
                >
                  {item.hesusService.needProduct && item.product.name}
                  {item.hesusService.needProduct &&
                    item.hesusService.needTransport &&
                    " - "}
                  {item.hesusService.needTransport && item.transport.name}
                </GridSubItem>
              </GridRow>
              <GridSubItem
                fontWeight="700"
                fontSize="16px"
                textAlign="right"
                color="#474747"
              >
                {renderPriceWithCurrency(
                  addSpace(
                    getConvertedPrice(
                      orderData?.currency?.id,
                      item?.sellingPrice,
                      exchangeRates
                    )
                  ),
                  t(item?.unit),
                  quoteCurrency?.symbol,
                  quoteCurrency?.position
                )}
              </GridSubItem>

              <GridSubItem
                fontWeight="700"
                fontSize="16px"
                textAlign="center"
                borderLeft="2px solid #767676"
              >
                {item?.clientOrderItem?.quantity}{" "}
                {t(item?.clientOrderItem?.unit)}
              </GridSubItem>
            </GridRow>
          </React.Fragment>
        );
      })}
    </SectionContainer>
  );
};

export default withTranslation()(OrderSummaryHistory);
